import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

import { useCurrentUser } from '@/hooks/useCurrentUser';

/**
 * Event ids the current user has requested deletion for (their kind 5
 * events), so deleted content can be hidden locally even on relays that
 * haven't honored the deletion.
 */
export function useMyDeletions() {
  const { nostr } = useNostr();
  const { user } = useCurrentUser();

  return useQuery<Set<string>>({
    queryKey: ['nostr', 'my-deletions', user?.pubkey ?? ''],
    queryFn: async () => {
      if (!user) return new Set<string>();

      const events = await nostr.query(
        [{ kinds: [5], authors: [user.pubkey], limit: 200 }],
        { signal: AbortSignal.timeout(4000) },
      );

      const ids = new Set<string>();
      for (const event of events) {
        for (const [name, value] of event.tags) {
          if (name === 'e' && value) ids.add(value);
        }
      }
      return ids;
    },
    enabled: !!user,
    staleTime: 60 * 1000,
  });
}
